import { render, staticRenderFns } from "./mini-group.vue?vue&type=template&id=32593eea&"
import script from "./mini-group.vue?vue&type=script&lang=js&"
export * from "./mini-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports